enum ContentActionType {
    CONTENT_REQUEST_DATA = "CONTENT_REQUEST_DATA",
    CONTENT_LOAD_DATA = "CONTENT_LOAD_DATA",
    CONTENT_DISPLAY_ERROR = "CONTENT_DISPLAY_ERROR",
}

export default ContentActionType;